import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@redux/reducers/rootReducer';

const manageCompany = (state: RootState) => state.crm.companies.manage;

const getManageState = createSelector(manageCompany, (state) => state);

export const companiesSelectors = {
  getManageState,
};
